enum ProductTypes {
  SET_ALL_PRODUCTS = '[PRODUCT] SET_ALL',
}

export default ProductTypes;
